"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function buttonKeyPressHandler(performOnEnterOrSpace) {
    return function (e) {
        if ((e.key == 'Enter' || e.key == ' ') && !!performOnEnterOrSpace) {
            e.preventDefault();
            performOnEnterOrSpace();
        }
    };
}
exports.buttonKeyPressHandler = buttonKeyPressHandler;
